import { jsonProperty, Serializable } from "ts-serializable";

class Category extends Serializable {
  @jsonProperty(String, null)
  id: string | null = null;

  @jsonProperty(String, null)
  nome: string | null = null;

  @jsonProperty(Number, null)
  intervaloMeses: number | null = null;

  @jsonProperty(Boolean)
  inativo: boolean = false;
}

export default Category;
